(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["navea-composeur"] && !Shopify.designMode) return;
  try {
    (function () {
  /**
   * Normalise une taille pour la comparaison du raccourci :
   * "L (40-42)" -> "L", "2XL" -> "XXL", "3XL" -> "XXXL".
   * Sans cela, le raccourci laisse de cote les grandes tailles
   * du Soutien-gorge Confort Plus (M a 3XL).
   */
  function normTaille(s) {
    s = String(s || '').trim().toUpperCase().split(' ')[0];
    var m = s.match(/^([2-9])XL$/);
    if (m) {
      var n = parseInt(m[1], 10);
      s = new Array(n + 1).join('X') + 'L';
    }
    return s;
  }

  function init(root) {
    if (root.dataset.naveaReady) return;
    root.dataset.naveaReady = '1';

    var total = parseInt(root.dataset.total, 10) || 0;
    var guide = root.dataset.guide === '1';
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-navea-slot]'));
    var prog = root.querySelector('[data-navea-prog]');
    var note = root.querySelector('[data-navea-note]');
    var noteVide = note ? note.textContent : '';
    var noteOk = note ? (note.getAttribute('data-ok') || '') : '';

    var scope = root.closest('.shopify-section, [data-section-id]') || document;
    var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (form && !form.id) form.id = 'navea-form-' + Math.random().toString(36).slice(2, 9);

    root.querySelectorAll('[data-navea-champ]').forEach(function (input) {
      if (form) input.setAttribute('form', form.id);
    });

    /* Tous les chemins d'achat de la page, pas seulement le bouton du formulaire. */
    function cheminsAchat() {
      var sel = [
        'form[action*="/cart/add"] [type="submit"]',
        '.add-to-cart-button',
        '.shopify-payment-button',
        'shopify-accelerated-checkout',
        '.sticky-add-to-cart',
        '[data-testid="sticky-add-to-cart"]'
      ].join(',');
      return Array.prototype.slice.call(document.querySelectorAll(sel));
    }

    function ligne(slot) { return slot.querySelector('[data-navea-bascule]'); }
    function corps(slot) { return slot.querySelector('[data-navea-corps]'); }

    function ouvrir(slot, oui) {
      var b = ligne(slot);
      var c = corps(slot);
      if (!b || !c) return;
      b.setAttribute('aria-expanded', oui ? 'true' : 'false');
      c.hidden = !oui;
    }

    function estOuvert(slot) {
      var b = ligne(slot);
      return !!b && b.getAttribute('aria-expanded') === 'true';
    }

    /* Etat d'une piece : renseigne le resume, la propriete de ligne,
       et dit si la piece est complete. */
    function etat(slot) {
      var selects = Array.prototype.slice.call(slot.querySelectorAll('[data-navea-select]'));
      var complet = selects.length > 0;
      var parts = [];
      selects.forEach(function (s) {
        if (!s.value) { complet = false; return; }
        parts.push(s.value);
      });

      var champ = slot.querySelector('[data-navea-champ]');
      if (champ) {
        if (complet) {
          champ.value = parts.join(' · ');
          champ.disabled = false;
        } else {
          champ.value = '';
          champ.disabled = true;
        }
      }

      var resume = slot.querySelector('[data-navea-resume]');
      if (resume) {
        if (parts.length) {
          resume.textContent = parts.join(' · ');
        } else {
          resume.textContent = resume.dataset.vide || resume.textContent;
        }
      }

      slot.classList.toggle('is-ok', complet);
      return complet;
    }

    function majuscule() {
      var faits = slots.filter(etat).length;
      if (prog) {
        prog.textContent = faits + ' / ' + total + (total > 1 ? ' pièces complètes' : ' pièce complète');
        prog.classList.toggle('is-done', faits === total);
      }
      var pret = faits === total;
      if (note) {
        note.textContent = pret ? (noteOk || noteVide) : noteVide;
        note.classList.toggle('is-done', pret);
      }
      cheminsAchat().forEach(function (el) {
        el.classList.toggle('navea-achat-bloque', !pret);
        if ('disabled' in el) el.disabled = !pret;
        el.setAttribute('aria-disabled', pret ? 'false' : 'true');
      });
      return pret;
    }

    /* Mode guide : on garde une seule piece ouverte, la premiere a completer.
       Sans ce mode, tout reste ouvert. */
    function suivante(depuis) {
      if (!guide) return;
      var cible = null;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i] === depuis) continue;
        if (!slots[i].classList.contains('is-ok')) { cible = slots[i]; break; }
      }
      slots.forEach(function (s) { ouvrir(s, s === cible); });
    }

    /* Memorise le libelle d'attente pour pouvoir y revenir. */
    slots.forEach(function (slot) {
      var r = slot.querySelector('[data-navea-resume]');
      if (r) r.dataset.vide = r.textContent.trim();
    });

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-navea-bascule]');
      if (!b || !root.contains(b)) return;
      e.preventDefault();
      var slot = b.closest('[data-navea-slot]');
      var ouvert = estOuvert(slot);
      if (guide && !ouvert) {
        slots.forEach(function (s) { ouvrir(s, s === slot); });
      } else {
        ouvrir(slot, !ouvert);
      }
    });

    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-navea-select]');
      if (!s || !root.contains(s)) return;
      /* Horizon ecoute les changements du formulaire produit : on garde
         nos listes deroulantes pour nous, sinon la section se recharge. */
      e.stopPropagation();
      var slot = s.closest('[data-navea-slot]');
      majuscule();
      if (slot && slot.classList.contains('is-ok')) suivante(slot);
    });

    var toutes = root.querySelector('[data-navea-toutes]');
    if (toutes) {
      toutes.addEventListener('change', function (e) {
        e.stopPropagation();
        var choix = toutes.value;
        if (!choix) return;
        var vise = normTaille(choix);
        slots.forEach(function (slot) {
          slot.querySelectorAll('[data-navea-select]').forEach(function (s) {
            if (s.dataset.cle !== 'taille') return;
            var cible = '';
            Array.prototype.slice.call(s.options).forEach(function (o) {
              if (o.value && normTaille(o.value) === vise) cible = o.value;
            });
            if (cible) s.value = cible;
          });
        });
        var pret = majuscule();
        if (guide) {
          if (pret) { slots.forEach(function (s) { ouvrir(s, false); }); }
          else { suivante(null); }
        }
      });
    }

    /* Horizon peut reactiver ses boutons apres une mise a jour du formulaire :
       on rejoue l'etat pour que le blocage tienne. */
    if (form) form.addEventListener('change', function () { setTimeout(majuscule, 0); });
    document.addEventListener('variant:update', function () { setTimeout(majuscule, 0); });

    majuscule();
    if (guide) { suivante(null); }
    else { slots.forEach(function (s) { ouvrir(s, true); }); }
  }

  function scan() { document.querySelectorAll('[data-navea-composeur]').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
  scan();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["navea-livraison"] && !Shopify.designMode) return;
  try {
    (function () {
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
    'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  /* On n'ajoute que des jours ouvres : ni samedi ni dimanche. Les jours
     feries ne sont pas pris en compte, d'ou le mot « estimee ». */
  function ouvres(depart, nb) {
    var d = new Date(depart.getTime());
    var restants = nb;
    while (restants > 0) {
      d.setDate(d.getDate() + 1);
      var j = d.getDay();
      if (j !== 0 && j !== 6) restants--;
    }
    return d;
  }

  function dire(d) {
    return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()];
  }

  function init(el) {
    if (el.dataset.naveaPret) return;
    el.dataset.naveaPret = '1';

    var cible = el.querySelector('[data-navea-liv-detail]');
    if (!cible) return;

    var n = function (k, r) { var v = parseInt(el.dataset[k], 10); return isNaN(v) ? r : v; };
    var aujourdhui = new Date();

    var tot = ouvres(aujourdhui, n('expMin', 1) + n('trMin', 4));
    var fin = ouvres(aujourdhui, n('expMax', 2) + n('trMax', 7));

    var texte = (el.dataset.avant || 'Livraison estimée entre le').trim();
    cible.textContent = texte + ' ' + dire(tot) + ' et le ' + dire(fin) + '.';
  }

  function scan() { document.querySelectorAll('[data-navea-livraison]').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
  } catch(e) { console.error(e); }
})();

})();
